import React from 'react'
import { Link } from 'react-router-dom'
import { Form } from './form'

const Content = () => {
  return (
    <div className="w-full lg:w-10/12 mx-auto h-screen flex items-center">
      <div className="md:p-10 lg:p-20 w-full bg-white lg:rounded h-full lg:h-auto">
        <div className="flex flex-wrap -mx-4">
          <div className="mx-auto lg:mx-0 w-1/2 px-4 h-auto pt-24 lg:pt-2">
            <img src="/images/bnpt_sign_in.svg" alt="sign up" className="mb-5 lg:mb-0 mx-auto"/>
          </div>
          <div className="w-full lg:w-1/2 px-4">
            <h1 className="text-2xl font-bold mb-3 font-primary text-center md:text-left">Forgot your password?</h1>
            <p className="text-sm text-gray-444 text-center md:text-left">Enter your email address below and we'll send you a link to reset your password.</p>

            <Form className="my-4 md:my-5 lg:my-8" />

            <p className="text-sm text-center md:text-left">
              <Link to="/login" className="link underline">Back to sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Content }
